import { SEND_WHATSAPP_MSG, SEND_WHATSAPP_MSG_FAILED, SEND_WHATSAPP_MSG_SUCCESS } from "./constants"

const initialState = {
    Loading: false,
    successMsg: "",
    errors: "",
}

const sendWhatsAppMsgReducer = (state = initialState, action) =>{
switch(action.type){
    case SEND_WHATSAPP_MSG:
        return{
            ...state,
            Loading: true,
            errors:"",
            successMsg:""
        }
    case SEND_WHATSAPP_MSG_SUCCESS:
        return{
            ...state,
            Loading: false,
            successMsg: action.payload
        }
    case SEND_WHATSAPP_MSG_FAILED:
        return{
            ...state,
            Loading: false,
            errors: action.payload
        }
    default: return state
}
}
export default sendWhatsAppMsgReducer;